class MessageParser {
  constructor(actionProvider, state) {
    this.actionProvider = actionProvider;
    this.state = state;
  }

  parse(message) {
    message = message.toLowerCase();
    // console.log(message);
    if (
      message.includes("product") ||
      message.includes("overview") ||
      message.includes("about") ||
      message.includes("what is intelle-sphere") ||
      message.includes("intelle-sphere overview") ||
      message.includes("platform") ||
      message.includes("job")
    ) {
      this.actionProvider.handleProductOverview();
      return;
    }

    if (
      message.includes("demo") ||
      message.includes("book") ||
      message.includes("schedule") ||
      message.includes("trial") ||
      message.includes("walkthrough") ||
      message.includes("meeting")
    ) {
      this.actionProvider.handleBookDemo();
      return;
    }

    if (
      message.includes("support") ||
      message.includes("help") ||
      message.includes("issue") ||
      message.includes("problem") ||
      message.includes("customer care") ||
      message.includes("contact")
    ) {
      this.actionProvider.handleContact();
      return;
    }
   
    if (
      message.includes("options") ||
      message.includes("help") ||
      message.includes("do for me")
    ) {
      return this.actionProvider.handleOptions({ withAvatar: true });
    }

    if (
      message.includes("talk") ||
      message.includes("speak") ||
      message.includes("real person") ||
      message.includes("call") ||
      message.includes("emergency") ||
      message.includes("contact")
    ) {
      return this.actionProvider.handleContact();
    }



    // if (message.includes("exam") || message.includes("test") || message.includes("marks") || message.includes("report card") || message.includes("results") || message.includes("grades")) {
    //   this.actionProvider.handleExams();
    //   return;
    // }


   


    if (message.includes("thanks") || message.includes("thank you")) {
      return this.actionProvider.handleThanks();
    }

    return this.actionProvider.handleOptions({ withAvatar: true });
  }
}

export default MessageParser;
